var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-outline-primary",attrs:{"type":"button"},on:{"click":_vm.copyFeedList}},[_vm._v("Copy feed API's")])}
var staticRenderFns = []

export { render, staticRenderFns }